export default function NebulaBackground() {
  return (
    <div className="bg">
      <div className="blob b1"></div>
      <div className="blob b2"></div>
      <div className="blob b3"></div>
      <div className="blob b4"></div>
      <div className="blob b5"></div>
      <div className="blob b6"></div>
    </div>
  );
}
